import { Component, OnInit } from '@angular/core';
import { NotificationStoreService, ConfigService, DatastoreService } from 'src/app/services/index';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {

  color = '';
  background = '';
  logo = '';
  urlLink = '';
  footerText = '';
  version: string = "";

  isDemo: boolean = false;

  constructor(
    private notifStore: NotificationStoreService,
    private dataStore: DatastoreService,
    ) {
  }

  ngOnInit(): void {
    this.version = this.dataStore.version;
    // subscribe to session updates for config changes
    this.notifStore.sessionUpdate.subscribe(() => {
      this.loadConfig();
    })
    this.loadConfig();

  }

  loadConfig() {
    const config = this.dataStore.config
    if (config) {
      const configJson = JSON.parse(config);
      this.color = configJson.text_colour;
      this.background = configJson.footer_colour;
      this.footerText = configJson.footer_text;
      this.logo = configJson.logo;
      this.urlLink = configJson.logo_link;
      if (configJson.hasOwnProperty('demo')) {
        this.isDemo = configJson.demo;
      }
    }
  }

}
